import React, { ReactNode } from 'react';
import './style.css';
import { Modal, Spinner } from '../../../ui';
import europcarLogo from '../../../ui/assets/europcar-logo.svg';
import { CustomerState } from '../../../redux/slices/customer-state';
import { LogoutNavButton } from '../navigation-button';
import { removeAuthConfig } from "../../../utils/auth-utils";
import { useAuth } from "react-oidc-context";
import { resetErrorDialog } from '../../../redux/slices/notification-slice';
import { useAppDispatch } from '../../../redux/hooks';
import { resetCustomer, setSearchTerm } from '../../../redux/slices/customer-slice';
import { useNavigate } from 'react-router-dom';

interface IHeaderProps {
  customer?: CustomerState;
  children: ReactNode | ReactNode[];
  leftNavActions?: ReactNode,
  loading?: boolean;
  errorDialog?: {
    message: string;
    title: string;
    code: string;
  }
}

export default function AppWrapper({ children, customer, leftNavActions, loading = false, errorDialog }: IHeaderProps) {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logout = () => {
    removeAuthConfig();
    auth.removeUser();
    auth.signoutRedirect({
      id_token_hint: auth.user?.id_token,
    });
    auth.clearStaleState();
  }

  const handleConfirmErrorDialog = () => {
    dispatch(resetErrorDialog());
  };

  const navigateToStartpage = () => {
    dispatch(setSearchTerm(undefined));
    dispatch(resetErrorDialog());
    dispatch(resetCustomer());
    navigate('/');
  };

  return (
    <div className="App">
      <div className="column">
        <header className="app-header" data-testid="heading">
          <div data-testid="CustomerSearchLabel" className="app-header__bar">
            <div data-testid="AppWrapperHeading" className="app-header__content">
              <button type="button" className="app-header__home" onClick={navigateToStartpage} title="Back to search">
                <img src={europcarLogo} alt="Back-Office MobilityApp" className="app-header__logo" />
              </button>
              <h1 className="app-header__title" data-testid="HeaderHeading">Back-Office MobilityApp</h1>
            </div>
          </div>
        </header>

        {
          customer ?
            <>
              <div className='navigation-bar'>
                <div className='navigation-left'>
                  {leftNavActions}
                </div>
                <div className='navigation-right'>
                  <LogoutNavButton onClickAction={logout} />
                </div>
              </div>
            </>
            :
            null
        }

        <div id="body-content" className="container">
          {children}
        </div>
      </div>

      <Spinner fullPage busy={loading} testId='searchSpinner' />

      <Modal
        shown={errorDialog?.code !== undefined}
        onClose={handleConfirmErrorDialog}
        onConfirm={handleConfirmErrorDialog}
        buttonConfirmLabel="Ok"
        buttonConfirmText="Ok"
        title={errorDialog?.title}
        status='error'
        testId='confirmErrorModal'
      >
        <p>{errorDialog?.message}</p>
      </Modal>

    </div>
  );
}
